import React from 'react'
import '../Component/css/Tree.css'
import { useNavigate } from 'react-router-dom'
import header from '../assets/product/tree/2.webp'
import header2 from '../assets/product/tree/3.webp'
import header3 from '../assets/product/tree/4.webp'
import treebg from '../assets/product/tree/1.webp'
import treeVideo from '../assets/product/tree/tree.mp4'




const Tree = () => {

  const navigate = useNavigate()

  return (
    <div className="about">
      <section className="about-section sec-padding">
        <div className="container">
          <h1 className='projecth1'>Product.</h1>
          <div className="project-row">
          <div className='tree-project'>
{/* IMAGE BACKGROUND */}
          <img src={treebg} alt="background" className='treebg' />

{/* TIMELINE */}
          <div className="tree-timeline">
            <ul className='tree-ul'>
                {/* <li className='tree-li'><div className="li">Role</div><span>Product Design and Frontend Development</span></li> */}
                <li className='tree-li'><div className="li">Challenge</div><span>As the Christmas season approaches, malls and store owners must get their customers in the holiday spirit to boost sales both online and offline.</span></li>
                <li className='tree-li'><div className="li">Sector</div><span>Commercial | Culture | Lifestyle </span></li>
                <li className='tree-li'><div className="li">Timeline</div><span>2 Month</span></li>
            </ul>
          </div>

{/* HEADER 1 */}
            <div className="tree-header-body">
              <div className="tree-header-detail">
                <div className="tree-header-text-one">
                  <div className="tree-main-text-one">
                    <h3>About</h3>
                    <div className="tree-icon">
                    <i class="fas fa-laptop"></i>
                    <i class="fas fa-tablet"></i>
                    </div>
                  </div>  
                    <p>
                    A Christmas Animation that provides malls and large retail spaces with a Christmas feeling. By following the KIS (Keep It Simple) method I was able to create an animation with a simple design without compromising aesthetics. The animation takes a creative approach to design and development. The source code is on my <strong><a href="https://github.com/TundeAdekoya/Christmas-animation" target="_blank" rel="noopener noreferrer">GitHub Repository</a></strong> and live on <strong><a href="https://chrismas-animation.vercel.app/" target="_blank" rel="noopener noreferrer">Vercel</a></strong>
                    </p>             
                </div>
              </div>

              <div className="tree-header-image-one">
                <img src={header} alt="Tree Header" />
              </div>
          </div>
{/* GOAL */}
            <div className="tree-goal">
              <div className="tree-goal-image">
                  <img src={header2} alt="Tree Goal" />
              </div>
              <div className="tree-goal-text">
                <h3>Goal</h3>
                <p>The aim of this project was to create a product that showcases the Christmas feeling. The product is targeted to consumers in commercial areas for the purpose of boosting sales and increasing the time spent at the mall during the Christmas festive period. </p>
              </div>
            </div>
{/* DESIGN PROCESS */}
            <div className="tree-detail">
              <div className="tree-detail-text">
                <div className="tree-detail-text-one">
                <h3>Design Process</h3>
                <p>Firstly, I researched the aesthetics of Christmas to know more about the holiday and why colours such as red, green and white are used for decorations. Lastly, I sketched designs and continued to the next phase of the design on Figma.</p>
                </div>
              </div>
            </div>  

            <div className="tree-goal-image">
                  <img src={header3} alt="Tree Goal" />
              </div>

            <div className="tree-detail">
              <div className="tree-detail-text">
                <div className="tree-detail-text-two">
                <h3>Development Process</h3>
                <p>To begin, the animation was created with HTML and CSS. HTML was used to structure the position of the elements in the animation and CSS to shape the tree and stars. Finally, I used CSS to style the animation background, tree, and stars.</p>
                </div>
              </div>
            </div>

{/* VIDEO */}
            <div className="tree-detail-image">
                <video src={treeVideo} controls></video>
            </div>

{/* ANIMATION */}
        <h2 className='tree-h2'><span>Thanks for scrolling</span></h2>

        <p className='tree-p'>Schedule a <a href="https://calendly.com/tunde_dev" target="_blank"  rel="noopener noreferrer">demo call</a> to learn more about this project.</p>
        </div>

{/* End work Detail */}
                    <div onClick={() => navigate('/Portfolio')} className="go_to1">
                        <p>Go back to Portfolio</p> 
                        <div className="icon">
                            <i class="fas fa-angle-right"></i>
                            <i class="fas fa-angle-right"></i>
                        </div>
                    </div>
      </div>
    </div>
  </section>
  </div>
  )
}

export default Tree